import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';

interface GuardProps {
  children: ReactNode;
}

const GuardGuest: FC<GuardProps> = ({ children }) => {
  return (
    <div><>
    {children}</></div>
  )
}

GuardGuest.propTypes = {
  children: PropTypes.node as any
};

export default GuardGuest